/*
 * @Author: Teemo Ding
 * @Date: 2021-06-01 09:33:37
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2021-06-01 11:22:09
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelCollection/common.ts
 */
enum EnumCollapseId {
  SeoSetting = 'SEOSetting',
  CollectionInfo = 'CollectionInfo',
  FeaturedImage = 'FeaturedImage',
  Products = 'Products',
}
export { EnumCollapseId };
